// removed by extract-text-webpack-plugin
module.exports = {"root":"Toolbox__root___3npX6","title":"Toolbox__title___xoD19","row":"Toolbox__row___1U-jP","colorPicker":"Toolbox__colorPicker___nwpax","label":"Toolbox__label___E8d9d"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/Hotel/Toolbox/Toolbox.scss
// module id = 986
// module chunks = 0